export default ({ instance }) => {
	return {
		getAllTours () {
        return instance({
            method: 'get',
            url: 'tour/searchTourAtivos',
            responseType: 'json',
        })
    },
    saveUserTour (data) {
        return instance({
            method: 'post',
            url: 'tour/insertUsuarioTour',
            //url: 'tours/teste',
            data: data
        })
    },
	};
};